import gql from 'graphql-tag';

const BUYER_INFO_FRAGMENT = gql`
  fragment BuyerInfoFragment on BuyerInfo {
    user_id
    dealer_id
  }
`;

export default BUYER_INFO_FRAGMENT;
